<template>
  <AuthMobileTemplate v-if="isSmallerThanLaptop" onboarding>
    <RouterView />
    <!-- <OnboardingForm is-mobile /> -->
  </AuthMobileTemplate>
  <AuthDesktopTemplate v-else>
    <template #form>
      <RouterView />
      <!-- <OnboardingForm /> -->
    </template>
  </AuthDesktopTemplate>
</template>

<script setup lang="ts">
import AuthMobileTemplate from "@follaw-fr/components/auth/templates/AuthMobileTemplate.vue";
import AuthDesktopTemplate from "@follaw-fr/components/auth/templates/AuthDesktopTemplate.vue";
import { useResponsive } from "@/commons/composables/useResponsive";

const { isSmallerThanLaptop } = useResponsive();
</script>
